var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "comprehensive-table-container" },
    [
      _c(
        "vab-query-form",
        [
          _c(
            "vab-query-form-top-panel",
            [
              _c(
                "el-form",
                {
                  ref: "queryForm",
                  attrs: {
                    inline: true,
                    "label-width": "100px",
                    model: _vm.queryForm
                  },
                  nativeOn: {
                    submit: function($event) {
                      $event.preventDefault()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "cont-form" }, [
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { prop: "jobNo" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "200px" },
                              attrs: {
                                placeholder: "运单号",
                                rows: 3,
                                type: "textarea"
                              },
                              model: {
                                value: _vm.queryForm.jobNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryForm, "jobNo", $$v)
                                },
                                expression: "queryForm.jobNo"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "柜号", prop: "cabinetNo" } },
                          [
                            _c("el-input", {
                              staticStyle: { width: "180px" },
                              attrs: { clearable: "", placeholder: "请输入" },
                              model: {
                                value: _vm.queryForm.cabinetNo,
                                callback: function($$v) {
                                  _vm.$set(_vm.queryForm, "cabinetNo", $$v)
                                },
                                expression: "queryForm.cabinetNo"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "my-form-item",
                            attrs: { label: "是否混箱", prop: "isMixed" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择类型"
                                },
                                model: {
                                  value: _vm.queryForm.isMixed,
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryForm, "isMixed", $$v)
                                  },
                                  expression: "queryForm.isMixed"
                                }
                              },
                              _vm._l(_vm.yseOrNo, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "my-form-item",
                            attrs: { label: "报关方式", prop: "customsType" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择类型"
                                },
                                model: {
                                  value: _vm.queryForm.customsType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryForm, "customsType", $$v)
                                  },
                                  expression: "queryForm.customsType"
                                }
                              },
                              _vm._l(_vm.customsType, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        ),
                        _c(
                          "el-form-item",
                          {
                            staticClass: "my-form-item",
                            attrs: { label: "清关方式", prop: "taxType" }
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "180px" },
                                attrs: {
                                  clearable: "",
                                  placeholder: "请选择类型"
                                },
                                model: {
                                  value: _vm.queryForm.taxType,
                                  callback: function($$v) {
                                    _vm.$set(_vm.queryForm, "taxType", $$v)
                                  },
                                  expression: "queryForm.taxType"
                                }
                              },
                              _vm._l(_vm.taxType, function(item) {
                                return _c("el-option", {
                                  key: item,
                                  attrs: { label: item, value: item }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            icon: "el-icon-search",
                            "native-type": "submit",
                            type: "primary"
                          },
                          on: { click: _vm.handleQuery }
                        },
                        [_vm._v(" 查询 ")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { "native-type": "submit" },
                          on: {
                            click: function($event) {
                              return _vm.reset("queryForm")
                            }
                          }
                        },
                        [_vm._v(" 重置 ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "vab-query-form-left-panel",
            [
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loadingExPort,
                    size: "mini",
                    type: "success"
                  },
                  on: { click: _vm.exPort }
                },
                [_vm._v(" 底单导出 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    loading: _vm.loadingExPortPri,
                    size: "mini",
                    type: "info"
                  },
                  on: { click: _vm.exPortPri }
                },
                [_vm._v(" 报关资料导出 ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          ref: "tableSort",
          attrs: {
            border: "",
            "cell-style": { padding: "2px" },
            data: _vm.list,
            "element-loading-text": "拼命加载中",
            height: _vm.height,
            "row-class-name": _vm.rowStyle,
            "row-style": { height: "30px" }
          },
          on: {
            "row-click": _vm.handleRowClick,
            "selection-change": _vm.setSelectRows
          },
          scopedSlots: _vm._u([
            {
              key: "empty",
              fn: function() {
                return [
                  _c("el-image", {
                    staticClass: "vab-data-empty",
                    attrs: {
                      src: require("@/assets/empty_images/data_empty.png")
                    }
                  })
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              "show-overflow-tooltip": "",
              type: "selection",
              width: "55"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              fixed: "left",
              label: "柜号",
              prop: "cabinetNo",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.cabinetNo) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              fixed: "left",
              label: "运单号",
              prop: "jobNo",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.jobNo) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "客户中文品名",
              prop: "cusProductCnName",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.cusProductCnName) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "客户英文品名",
              prop: "cusProductEnName",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.cusProductEnName) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "海关编码",
              prop: "hsCode",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.hsCode) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "申报中文品名",
              prop: "reportCnName",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.reportCnName) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "申报英文品名",
              prop: "reportEnName",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.reportEnName) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "中国海关编码",
              prop: "hsCodeCn",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.hsCodeCn) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "中国申报要素",
              prop: "reportFactor",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.reportFactor) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "中文材质",
              prop: "materialCn",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.materialCn) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "英文材质",
              prop: "materialEn",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.materialEn) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "子单号",
              prop: "childJobNo",
              "show-overflow-tooltip": "",
              width: "240"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "品牌",
              prop: "brand",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.brand) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "品牌类型",
              prop: "brandType",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.brandType) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "规格",
              prop: "specs",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.specs) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "用途",
              prop: "uses",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.uses) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "货物类型",
              prop: "goodsType",
              width: "120"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.goodsType) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "单位",
              prop: "unit",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.unit) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "件数",
              prop: "pcs",
              "show-overflow-tooltip": "",
              width: "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "净重",
              prop: "netWeight",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.netWeight) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "毛重",
              prop: "grossWeight",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "收货总净重",
              prop: "receiveNetWeight",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "收货总实重",
              prop: "receiveGrossWeight",
              width: "100"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "体积",
              prop: "vol",
              "show-overflow-tooltip": "",
              width: "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "数量",
              prop: "qty",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.qty) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "单价",
              prop: "price",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.price) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "总价",
              prop: "totalPrice",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.totalPrice) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "长",
              prop: "length",
              "show-overflow-tooltip": "",
              width: "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "宽",
              prop: "width",
              "show-overflow-tooltip": "",
              width: "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: "高",
              prop: "height",
              "show-overflow-tooltip": "",
              width: "80"
            }
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              fixed: "right",
              label: "链接",
              prop: "transactionUrl",
              "show-overflow-tooltip": "",
              width: "140"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c(
                          "a",
                          {
                            attrs: {
                              href: item.transactionUrl,
                              target: "_blank"
                            }
                          },
                          [_vm._v(" " + _vm._s(item.transactionUrl) + " ")]
                        )
                      ]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "报关方式",
              prop: "customsType",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.customsType) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "清关方式",
              prop: "taxType",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.taxType) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "创建人",
              prop: "createBy",
              width: "100"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.createBy) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              label: "创建时间",
              prop: "createTime",
              width: "160"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [_vm._v(" " + _vm._s(item.createTime) + " ")]
                    )
                  })
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              "class-name": "myCell",
              fixed: "right",
              label: "是否混装",
              prop: "isMixed",
              width: "80"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return _vm._l(scope.row.list, function(item, index) {
                    return _c(
                      "div",
                      {
                        key: index,
                        staticClass: "myCellDiv",
                        staticStyle: { "text-align": "center" }
                      },
                      [
                        _c(
                          "span",
                          [
                            _c("el-tag", { attrs: { type: "success" } }, [
                              _vm._v(_vm._s(item.isMixed))
                            ])
                          ],
                          1
                        )
                      ]
                    )
                  })
                }
              }
            ])
          })
        ],
        1
      ),
      _c("div", { staticClass: "cont" }, [
        _vm._v(" 全部合计： "),
        _c("span", [_vm._v("订单毛重：" + _vm._s(_vm.fomr.totalGrossWeight))]),
        _c("span", [_vm._v("订单净重：" + _vm._s(_vm.fomr.totalNetWeight))]),
        _c("span", [
          _vm._v("收货毛重：" + _vm._s(_vm.fomr.totalReceiveGrossWeight))
        ]),
        _c("span", [
          _vm._v("收货净重：" + _vm._s(_vm.fomr.totalReceiveNetWeight))
        ]),
        _c("span", [_vm._v("件数：" + _vm._s(_vm.fomr.totalPcs))]),
        _c("span", [_vm._v("总数量：" + _vm._s(_vm.fomr.totalQty))]),
        _c("span", [_vm._v("金额：" + _vm._s(_vm.fomr.totalPrice))]),
        _c("span", [_vm._v("体积：" + _vm._s(_vm.fomr.totalVol))])
      ]),
      _c("div", { staticClass: "cont" }, [
        _vm._v(" 选中数据合计： "),
        _c("span", [_vm._v("订单毛重：" + _vm._s(_vm.selectForm.grossWeight))]),
        _c("span", [_vm._v("订单净重：" + _vm._s(_vm.selectForm.netWeight))]),
        _c("span", [
          _vm._v("收货毛重：" + _vm._s(_vm.selectForm.receiveGrossWeight))
        ]),
        _c("span", [
          _vm._v("收货净重：" + _vm._s(_vm.selectForm.receiveNetWeight))
        ]),
        _c("span", [_vm._v("件数：" + _vm._s(_vm.selectForm.pcs))]),
        _c("span", [_vm._v("总数量：" + _vm._s(_vm.selectForm.qty))]),
        _c("span", [_vm._v("金额：" + _vm._s(_vm.selectForm.totalPrice))]),
        _c("span", [_vm._v("体积：" + _vm._s(_vm.selectForm.vol))])
      ]),
      _c("el-pagination", {
        attrs: {
          background: "",
          "current-page": _vm.queryForm.pageNum,
          layout: _vm.layout,
          "page-size": _vm.queryForm.pageSize,
          "page-sizes": [100, 200, 300, 500, 1000],
          total: _vm.total
        },
        on: {
          "current-change": _vm.handleCurrentChange,
          "size-change": _vm.handleSizeChange
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }